import React, { Component } from 'react';
import { translate } from '../../utils/lang-adapters';
import '../../css/match-form.css';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

class MatchForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: this.getIsOpenState(),
        };
    }

    getIsOpenState() {
        // Retrieve the object from storage
        let isOpen = true;
        try {
            isOpen = JSON.parse(localStorage.getItem('settings')).matchPage.isOpenForm
        } catch (error) { }
        return isOpen;
    }

    setIsOpenState(newState) {
        // Retrieve the object from storage
        let storedState = JSON.parse(localStorage.getItem('settings'));
        storedState = {
            ...storedState,
            matchPage: {
                ...storedState.matchPage,
                isOpenForm: newState,
            }
        }
        // Put the object into storage
        localStorage.setItem('settings', JSON.stringify(storedState));
    }

    toggleMenu() {
        const newState = !this.state.open;
        this.setIsOpenState(newState);
        this.setState({
            open: newState
        })
    }


    renderLast6Matches(formArray, teamId, sort) {
        if (formArray.length > 0) {
            return (
                formArray.map(each => {
                    if (each.competition === this.props.data.competition_id && each.team_id === teamId) {
                        // do not print matches from group competition -1 because it will be matches of all competitions and we dont have details to print that
                        return each.form.sort((a, b) => {
                            const dateA = new Date(a.date_utc);
                            const dateB = new Date(b.date_utc);
                            if (sort === 'left') {
                                return (dateA < dateB) ? -1 : 1;
                            } else if (sort === 'right') {
                                return (dateA > dateB) ? -1 : 1;
                            }
                            return 0;
                        }).map((eachMatch, index) => {
                            return (
                                <span key={index} className="item">
                                    <Link className="form-match" to={"/match/" + eachMatch.match_id} >
                                        <div data-title={eachMatch.date_utc}>{eachMatch.outcome}</div>
                                    </Link>
                                </span>
                            )
                        })
                    }
                    else return null
                })
            )
        }
    }

    render() {
        return (
            <div className="match-form">
                <div className="title-form" onClick={() => this.toggleMenu()}>
                    <div className="icons">
                        <span className="ball">
                            <img src="/img/ultimos-resultados.svg" alt="" width="20" />
                        </span>
                        <h2>Últimos Resultados</h2>
                    </div>
                    <img className={classNames(this.state.open && "rotate-icon")} src="/img/arrow.svg" alt="arrow" width="20" />
                </div>
                <div className={classNames("div-form", !this.state.open && 'd-none')}>
                    <div className="form-div">
                        <div className="form-A">
                            <span className="teamA-name">
                                {
                                    translate(this.props.data.team_A_name)
                                }
                            </span>
                            <span>
                                <p className="result-form">RESULTADO</p>
                                <span className="body-form left">{this.renderLast6Matches(this.props.data.form, this.props.data.team_A_id, 'left')}</span>
                            </span>
                        </div>
                        <div className="vs">VS</div>
                        <div className="form-B">
                            <span className="teamB-name">
                                {
                                    translate(this.props.data.team_B_name)
                                }
                            </span>
                            <span>
                                <p className="result-form">RESULTADO</p>
                                <span className="body-form right">{this.renderLast6Matches(this.props.data.form, this.props.data.team_B_id, 'right')}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MatchForm;